import type { OlTest, OlTestUserAnswer } from '@modules/types/graphql';

export type StartTestFormValues = {
    id: string;
    userId: string;
    subjectId: string;
    courseId: string;
    questionIds: string[];
    answers?: {
        answerIds: string[];
        questionId: string;
    }[];
    maxScore: number;
    resultScore: number;
    resultSuccess: boolean;
    startedAt: string;
    endTime: string;
    finished: boolean;
    finishedAt: string;
};

class StartTestRequest {
    id: OlTest['id'];
    userId: OlTest['userId'];
    subjectId: OlTest['subjectId'];
    courseId: OlTest['courseId'];
    questionIds: OlTest['questionIds'];
    answers: OlTestUserAnswer[];
    maxScore: OlTest['maxScore'];
    resultScore: OlTest['resultScore'];
    resultSuccess: OlTest['resultSuccess'];
    startedAt: OlTest['startedAt'];
    endTime: OlTest['endTime'];
    finished: OlTest['finished'];
    finishedAt: OlTest['finishedAt'];

    constructor(values: StartTestFormValues) {
        this.id = values.id;
        this.userId = values.userId;
        this.subjectId = values.subjectId;
        this.courseId = values.courseId;
        this.questionIds = values.questionIds ? values.questionIds : [];
        this.answers = values.answers ? values.answers : [];
        this.maxScore = values.maxScore;
        this.resultScore = values.resultScore;
        this.resultSuccess = values.resultSuccess;
        this.startedAt = values.startedAt;
        this.endTime = values.endTime;
        this.finished = values.finished;
        this.finishedAt = values.finishedAt;
    }
}

export { StartTestRequest };
